import { v4 as uuid } from 'uuid';
// Views
import WorkplaceDeleteModalView from './WorkplaceDeleteModal/WorkplaceDeleteModalView.html';
import './Workplace.scss';
// Controllers
import { ChannelCommomController } from '../ChannelCommomController';
import { WorkplaceDeleteModalController } from './WorkplaceDeleteModal/WorkplaceDeleteModalController';
import { ChannelsNames } from '../Channels';
// Features
import { ChannelsFeatures } from '../ChannelsFeatures';
export class WorkplaceController extends ChannelCommomController {
    static $inject = ['application', 'ConfigurationsService', 'BLIP_DOMAIN_URL', 'WORKPLACE_AUTH_URL', 'WORKPLACE_AUTH_PERMISSIONS', 'BlipToastService', 'LoadingService', 'WorkplaceSegmentService', 'WorkplaceService', 'PermissionsService', 'ModalService', '$translate', '$window', '$cookies', '$timeout', 'ChannelsService', 'FACEBOOK_POPUP_CONNECTION_TIME'];
    handleWorkplaceLogin() { }
    constructor(application, ConfigurationsService, BLIP_DOMAIN_URL, WORKPLACE_AUTH_URL, WORKPLACE_AUTH_PERMISSIONS, BlipToastService, LoadingService, WorkplaceSegmentService, WorkplaceService, PermissionsService, ModalService, $translate, $window, $cookies, $timeout, ChannelsService, FACEBOOK_POPUP_CONNECTION_TIME) {
        'ngInject';
        super('workplace', ConfigurationsService);
        this.application = application;
        this.ConfigurationsService = ConfigurationsService;
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
        this.WORKPLACE_AUTH_URL = WORKPLACE_AUTH_URL;
        this.WORKPLACE_AUTH_PERMISSIONS = WORKPLACE_AUTH_PERMISSIONS;
        this.BlipToastService = BlipToastService;
        this.LoadingService = LoadingService;
        this.WorkplaceSegmentService = WorkplaceSegmentService;
        this.WorkplaceService = WorkplaceService;
        this.PermissionsService = PermissionsService;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.$window = $window;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.ChannelsService = ChannelsService;
        this.FACEBOOK_POPUP_CONNECTION_TIME = FACEBOOK_POPUP_CONNECTION_TIME;
        this.uninstalledThirdPartyApp = false;
        this.hasWritePermission = false;
        this.connectionButtonDisabled = true;
        this.isApplicationNameValid = () => {
            return Boolean(this.applicationName &&
                this.applicationName.length <= 50 &&
                this.applicationName.length > 0);
        };
        this.onInputChange = (event) => {
            this.applicationName = event.detail.value;
            const isValid = this.isApplicationNameValid();
            this.setDisconnectButtonDisabled(!isValid);
        };
        this.setDisconnectButtonDisabled = (isDisabled) => {
            this.$timeout(() => {
                this.connectionButtonDisabled = isDisabled;
            });
        };
        this.redirectUri = `${this.BLIP_DOMAIN_URL.replace(/\/\s*$/, '')}/facebookCallback`;
        this.handleWorkplaceLogin = this.onWorkplaceLogin.bind(this);
    }
    async $onInit() {
        this.LoadingService.startLoading();
        await this.checkFeatures();
        this.resetApplicationName();
        this.WorkplaceSegmentService.setApplication(this.application);
        const { AppId, AuthApiVersion } = await this.loadApplicationInformation();
        this.appId = AppId;
        this.authApiVersion = AuthApiVersion;
        const gotConfigurations = await this.getChannelConfigurations(this.isConfigurationsApplicationsDomainUsageGetEnabled);
        if (!gotConfigurations) {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('workplace.errorMsg.3'),
            });
        }
        this.hasWritePermission = await this.PermissionsService.hasPermissions('write', 'channels');
        this.checkWorkplaceThirdPartyAppUninstalled();
        this.LoadingService.stopLoading();
    }
    async checkFeatures() {
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsSetEnabled();
    }
    checkWorkplaceThirdPartyAppUninstalled() {
        this.uninstalledThirdPartyApp = this.configurations
            && this.configurations.UninstalledThirdPartyApp === 'True' ? true : false;
    }
    resetApplicationName() {
        this.applicationName = undefined;
    }
    async disableChannel() {
        const deletedConfigurations = await this.deleteChannelConfigurations(this.isConfigurationsApplicationsDomainUsageSetEnabled, this.isConfigurationsApplicationsDomainUsageGetEnabled);
        this.checkWorkplaceThirdPartyAppUninstalled();
        this.resetApplicationName();
        if (deletedConfigurations) {
            this.BlipToastService.show('success', {
                title: await this.$translate('workplace.successMsg.3'),
                msg: await this.$translate('workplace.successMsg.4'),
            });
        }
        else {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('workplace.errorMsg.2'),
            });
        }
    }
    async openDisableModal() {
        this.WorkplaceSegmentService.trackConnectionWorkplaceChatUninstallClicked();
        try {
            await this.ModalService.showModal({
                template: WorkplaceDeleteModalView,
                controller: WorkplaceDeleteModalController,
                controllerAs: '$ctrl',
                inputs: {
                    configurations: this.configurations,
                    onDelete: this.disableChannel.bind(this),
                    WorkplaceSegmentService: this.WorkplaceSegmentService,
                },
            });
        }
        catch (err) {
            console.error(err);
        }
    }
    async onWorkplaceLogin() {
        const { code, state } = this.$cookies.getObject(this.state);
        // Check if message is from popup
        if (state !== this.state) {
            return;
        }
        this.WorkplaceSegmentService.trackConnectionWorkplaceChatInstallConfirmed();
        this.LoadingService.startLoading();
        try {
            const tokenCommandResponse = await this.WorkplaceService.getTokenInfo(code, this.redirectUri);
            if (tokenCommandResponse.status == 'failure') {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('workplace.errorMsg.1'),
                    msg: tokenCommandResponse.reason.description,
                });
                return;
            }
            const { resource } = tokenCommandResponse;
            const configurationPayload = {
                ApplicationType: resource.applicationType,
                CommunityId: resource.communityId,
                InstallId: resource.installId,
                IsChannelActive: 'True',
                PageAccessToken: resource.pageAccessToken,
                PageId: resource.pageId,
                PageName: resource.pageName,
                UninstalledThirdPartyApp: 'False',
            };
            await this.ConfigurationsService.set('postmaster@workplace.gw.msging.net', configurationPayload, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            this.BlipToastService.show('success', {
                title: await this.$translate('workplace.successMsg.1'),
                msg: await this.$translate('workplace.successMsg.2'),
            });
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.$cookies.remove(this.state);
            this.getChannelConfigurations(this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.LoadingService.stopLoading();
        }
    }
    openLoginPopup() {
        this.WorkplaceSegmentService.trackConnectionWorkplaceChatInstallClicked();
        this.state = uuid();
        clearInterval(this.timerId);
        // do not indent this url, a whitespace will generate a '%20' on URL and fail the popup
        const url = `${this.WORKPLACE_AUTH_URL}/${this.authApiVersion}/dialog/work/app_install/?app_id=${this.appId}&suggested_page_name=${this.applicationName}&redirect_uri=${this.redirectUri}&state=${this.state}&permissions=${this.WORKPLACE_AUTH_PERMISSIONS}`;
        this.$window.open(url, 'Login With Workplace', 'height=685,width=610,location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes');
        // now plus Facebook popup connection time
        const timeToStopPoolingFacebookCookie = new Date(new Date().getTime() + this.FACEBOOK_POPUP_CONNECTION_TIME);
        // there is a issue when facebook calls the callback uri we lost the window reference
        // this reference was necessary to know when the window was closed and start the handle method
        // the way we agreed is a workaround pooling the cookie saved in FacebookCallbackController
        // and when its filled we stop the polling and start the handle method
        this.timerId = setInterval(() => {
            if (this.isCookieFilled(this.state)) {
                clearInterval(this.timerId);
                this.handleWorkplaceLogin();
            }
            if (new Date() > timeToStopPoolingFacebookCookie) {
                clearInterval(this.timerId);
            }
        }, 2000);
    }
    trackDocumentationClick() {
        this.WorkplaceSegmentService.trackConnectionWorkplaceChatDocumentationClicked();
    }
    async openDocumentation() {
        this.trackDocumentationClick();
        const documentationLink = await this.$translate('workplace.documentationLink');
        this.$window.open(documentationLink, '_blank', 'noopener noreferrer');
    }
    isCookieFilled(key) {
        const cookie = this.$cookies.getObject(key);
        return !!cookie;
    }
    async loadApplicationInformation() {
        const result = await this.ChannelsService.getFacebookAppInformation(ChannelsNames.Workplace);
        return result;
    }
}
WorkplaceController.$inject = ['application', 'ConfigurationsService', 'BLIP_DOMAIN_URL', 'WORKPLACE_AUTH_URL', 'WORKPLACE_AUTH_PERMISSIONS', 'BlipToastService', 'LoadingService', 'WorkplaceSegmentService', 'WorkplaceService', 'PermissionsService', 'ModalService', '$translate', '$window', '$cookies', '$timeout', 'ChannelsService', 'FACEBOOK_POPUP_CONNECTION_TIME'];
